<template>
  <div class="page_header">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
        <router-link
          v-if="item.name != name && index != 1"
          :to="{ path: item.path === '' ? '/' : item.path }"
        >{{ item.meta.title }}</router-link>
        <span v-else>{{ item.meta.title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="title">
      <h1 v-if="$route.path === '/'" class="title">{{ title }}</h1>
      <el-page-header v-else class="title" @back="goBack" :content="title"></el-page-header>
    </template>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: {
      type: [String, Boolean],
      default: true,
      required: false
    }
  },
  created () {
    this.getBreadcrumb()
  },
  data () {
    return {
      name: '',
      breadList: []
    }
  },
  methods: {
    getBreadcrumb () {
      this.breadList = [];
      // this.breadList.push({name: 'index', path: '/dashboard/', meta: {title: '首页'}})

      this.name = this.$route.name;
      this.$route.matched.forEach(item => {
        // item.name !== 'index' && this.breadList.push(item)
        this.breadList.push(item)
      })
    },
    goBack () {
      this.$router.go(-1);
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  }
}
</script>

<style scoped>
  .page_header {
    min-height: 60px;
    box-sizing: border-box;
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
  }
  .page_header .title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    color: rgba(0, 0, 0, 0.85);
    flex: auto;
    margin: 0.67em 0 16px;
  }
  .page_header .el-breadcrumb__inner a {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader/index.vue